
import { takeLatest, put, call } from 'redux-saga/effects';
import {
    SEARCH_PARAMETER, seacrhResultsFailure, searchResults, SEARCH_SECTION_TEMPLATE, OVERRIDDING_RISKFACTOR_SEARCH, SCORECARD_SEARCH, COUNTRY_AUTOCOMPLETE, STATE_AUTOCOMPLETE
} from './action';
import { SCORE_DEFINATION, REPORT, CORE_API } from '../../../config';
import { HTTP_HEADERS } from '../../../constants';
import request from '../../../components/Utils/httpHelper';

export function* sorecardRiskFactorSearch(action) {
    let requestUrl = `${SCORE_DEFINATION}/riskfactor/autocomplete/${action.data.id}/${action.data.search}`;
    try {
        const searchResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(searchResults(searchResult.data));
    } catch (err) {
        yield put(seacrhResultsFailure(err))
    }
}
export function* getScorecardRiskFactorSearch() {
    yield takeLatest(SEARCH_PARAMETER, sorecardRiskFactorSearch);
}

export function* getSectionTemplateSearch(action) {
    let requestUrl = `${REPORT}/section/search/${action.data}`;
    try {
        const searchResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(searchResults(searchResult.data));
    } catch (err) {
        yield put(seacrhResultsFailure(err))
    }
}
export function* sectionTemplateSearch() {
    yield takeLatest(SEARCH_SECTION_TEMPLATE, getSectionTemplateSearch);
}


export function* overriddingRiskFactorSearch(action) {
    let requestUrl = `${SCORE_DEFINATION}/overridingriskfactor/autocomplete/${action.data}`;
    try {
        const searchResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(searchResults(searchResult.data));
    } catch (err) {
        yield put(seacrhResultsFailure(err))
    }
}
export function* getOverriddingRiskFactorSearch() {
    yield takeLatest(OVERRIDDING_RISKFACTOR_SEARCH, overriddingRiskFactorSearch);
}

export function* scorecardSearch(action) {
    let requestUrl = `${SCORE_DEFINATION}/scorecard/search/${action.data}`;
    try {
        const searchResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });//yield call(Axios.get, requestURL, { headers: httpHeaders });
        yield put(searchResults(searchResult.data));
    } catch (err) {
        yield put(seacrhResultsFailure(err))
    }
}
export function* getScorecardSearch() {
    yield takeLatest(SCORECARD_SEARCH, scorecardSearch);
}

export function* countryAutoComplete(action) {
    let requestUrl = `${CORE_API}/autocomplete/country/${action.data}`;
    try {
        const searchResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(searchResults(searchResult.data));
    } catch (err) {
        yield put(seacrhResultsFailure(err))
    }
}
export function* getCountryAutoCompleteSearch() {
    yield takeLatest(COUNTRY_AUTOCOMPLETE, countryAutoComplete);
}

export function* stateAutoComplete(action) {
    let requestUrl = `${CORE_API}/autocomplete/${action.data.country}/state/${action.data.search}`;
    try {
        const searchResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(searchResults(searchResult.data));
    } catch (err) {
        yield put(seacrhResultsFailure(err))
    }
}
export function* getStateAutoCompleteSearch() {
    yield takeLatest(STATE_AUTOCOMPLETE, stateAutoComplete);
}